import {IAmplitudeOfferPromotionTrackingParams} from "../../../promotion/tracking/get_amplitude_offer_promotion_event_properties";
import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";

export const OFFER_LISTING_PROMOTION_CARD_ANALYTICS_ID = "promotion_card";

export const getAmplitudeOfferListingPromotionCardTrackingContext = (
    promotionContent: string,
    amplitudeItemListContext?: IAmplitudeItemListContext
): IAmplitudeOfferPromotionTrackingParams => ({
    creativeName: OFFER_LISTING_PROMOTION_CARD_ANALYTICS_ID,
    creativeSlot: OFFER_LISTING_PROMOTION_CARD_ANALYTICS_ID,
    promotionName: OFFER_LISTING_PROMOTION_CARD_ANALYTICS_ID,
    promotionContent,
    location: "listing_page",
    itemListId: amplitudeItemListContext?.itemListId
});
import {IAmplitudeOfferPromotionTrackingParams} from "../../../promotion/tracking/get_amplitude_offer_promotion_event_properties";
import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";

export const OFFER_LISTING_PROMOTION_CARD_ANALYTICS_ID = "promotion_card";

export const getAmplitudeOfferListingPromotionCardTrackingContext = (
    promotionContent: string,
    amplitudeItemListContext?: IAmplitudeItemListContext
): IAmplitudeOfferPromotionTrackingParams => ({
    creativeName: OFFER_LISTING_PROMOTION_CARD_ANALYTICS_ID,
    creativeSlot: OFFER_LISTING_PROMOTION_CARD_ANALYTICS_ID,
    promotionName: OFFER_LISTING_PROMOTION_CARD_ANALYTICS_ID,
    promotionContent,
    location: "listing_page",
    itemListId: amplitudeItemListContext?.itemListId
});
